import React from "react";

export function NotFound() {
    return <div className="flex justify-center items-center h-90% text-center">404</div>
}
